    import React from 'react';

    function ResultScreen({ resultData, onRestart }) {
    // 쉼표로 구분된 여행지 문자열을 배열로 만듭니다.
    const recommendArray = resultData.recommend.split(', ');

    return (
        <div className="screen-container result-screen">
        <p className="result-subtitle">{resultData.subtitle}</p>
        <h1 className="result-title">{resultData.title}</h1>
        
        <div className="result-card">
            <p className="result-desc">{resultData.description}</p>
            
            <div className="recommend-box">
            <h3>✈️ 추천 여행지</h3>
            {/* 배열을 순회하며 태그를 생성합니다. */}
            <div className="recommend-list">
                {recommendArray.map((place, index) => (
                <span key={index} className="recommend-tag">
                    {place.trim()}
                </span>
                ))}
            </div>
            </div>
        </div>

        <button className="primary-btn" onClick={onRestart}>
            테스트 다시하기
        </button>
        </div>
    );
    }

    export default ResultScreen;